module.exports = __webpack_public_path__ + "static/media/lock.693fd934.svg";